
export default function SettingsPage() {
  return (
    <div>
      <h1>Settings Page</h1>
    </div>
  )
}